import React, { useState } from "react";
import "../styles/Review.css"; // Ensure this path is correct

const Review = () => {
  const [rating, setRating] = useState("");
  const [feedback, setFeedback] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(`Rating: ${rating}\nFeedback: ${feedback}`);
    setRating("");
    setFeedback("");
  };

  return (
    <div className="review-container">
      <h1 className="review-title">Leave a Review</h1>
      <form className="review-form" onSubmit={handleSubmit}>
        <label htmlFor="rating">Rating</label>
        <select
          id="rating"
          value={rating}
          onChange={(e) => setRating(e.target.value)}
        >
          <option value="">Select Rating</option>
          {[5, 4, 3, 2, 1].map((num) => (
            <option key={num} value={num}>
              {num}
            </option>
          ))}
        </select>

        <label htmlFor="feedback">Feedback</label>
        <textarea
          id="feedback"
          placeholder="Write your feedback here..."
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
          rows={5}
        />

        <button type="submit">Submit Review</button>
      </form>
    </div>
  );
};

export default Review;
